/* eslint-disable no-param-reassign */
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import Snackbar from '@mui/material/Snackbar';
import Stack from '@mui/material/Stack';
import { Typography, Grid, SnackbarContent } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Info } from '@material-ui/icons';
import store from '../../redux/store';
import Groups from './components/Groups';
import { handleMarketplaceBasedOnSelection } from '../../shared/utils/helpers';
import { auditTrail, fetchGlobalSettings } from '../../services/killshot';
import * as pricingActionsImport from '../../redux/actions/pricing';
import * as groupsActionsImport from '../../redux/actions/refresh-groups';
import { savePricingGroup } from '../../redux/actions/pricing';
import { usePricing } from '../../context/pricing-context';
import { refreshInventory, refreshGroupedListings } from '../../redux/actions/refresh-groups-inventory';
import { setDeleteGroupModalOpen, setBadGroups } from '../../redux/actions/groups';
import { setCompAllGroupAction } from '../../redux/actions/groups-listings';

import {
  refreshGroups,
  setGroupsAction,
  updateGroupFields,
  setPushEnableAction,
  setMPAction,
} from '../../redux/actions/refresh-groups';

import {
  convertToArray,
  setSectionsGroup,
  setMarketplaceGroup,
  getGroupMarkets,
  validateGroupChanges,
  saveGroupChanges,
  hasValues,
} from '../../helpers/pricing';
import { MARKETPLACE_ITEMS, PUSH_TO_SB_ENABLE, BROADCASTING_STRATEGY_OPTIONS } from '../../helpers/constants';

const styles = makeStyles({
  groupDeletedSnackBarLight: {
    backgroundColor: '#FFFFFF',
  },
  groupDeletedSnackBarDark: {
    backgroundColor: '#2D3436',
  },
  fillBar: {
    height: 5,
    position: 'absolute',
    bottom: 0,
    left: 0,
    animation: '$fillAnimation 6000ms linear',
    zIndex: 1,
  },
  '@keyframes fillAnimation': {
    from: {
      width: 0,
    },
    to: {
      width: '100%',
    },
  },
});

const GroupsContainer = ({
  SBEventMeta,
  isPricingLoading,
  currTNCompSections,
  typeListing,
  zones,
  groupedListings,
  groups,
  initialGroups,
  initMarketplaces,
  groupFields,
  isPushEnable,
  isCompAllGroup,
  activeMarketplaces,
  eventInfo,
  deleteGroupSnackOpen,
  deletedGroupName,
  marketplaces,
  compsLoading,
  groupsMarketplaceComps,
  ...props
}) => {
  const inventory = groupedListings;
  const [isLoading, setLoading] = useState(false);
  const [editFlags, setEditFlags] = useState([]);
  const [errorFlags, setErrorFlags] = useState([]);
  const [initSBId, setInitSBId] = useState(0);
  const [settings, setSettings] = useState({});
  const [groupCriteria, setGroupCriteria] = useState({});
  const [isPushEventModalOpen, setIsPushEventModalOpen] = useState(false);
  const [isSnackbar, setIsSnackbar] = useState(false);
  const [count, setCount] = useState(0);
  const [updateCounter] = useState(1);
  const [groupSortingCriteria, setGroupSortingCriteria] = useState('default');
  const [isSaving, setSaving] = useState(false);
  const [updateListingsOnSave, setUpdateListingsOnSave] = useState(false);
  const classes = styles();
  const theme = useTheme();
  const history = useHistory();
  const timerDuration = 6000;
  const PUSH_TO_SB_V2_ENABLED = true;
  const handleSnackBarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    store.dispatch(setDeleteGroupModalOpen(false));
  };
  const { tags } = usePricing();

  const handleGroupCriteriaChanges = (groupId, action) => {
    const groupCriteriaCopy = { ...groupCriteria };
    groupCriteriaCopy[groupId] = action;
    setGroupCriteria(groupCriteriaCopy);
  };

  const validateChanges = (
    groupEdited,
    field,
    groupId,
    checkValue = false,
    initValue = null,
    currentValue = null,
    comingFrom = null
  ) => {
    let id = 0;
    let enablePush = {};
    if (initialGroups && Array.isArray(initialGroups) && initialGroups.length > 0) {
      // Compare changes
      if (groupEdited) {
        id = groupEdited.id;
        const initGroup = initialGroups.find(init => init.id === id);
        enablePush = validateGroupChanges(initGroup, groupEdited, field);
      } else {
        id = groupId;
        const isEnablePush = PUSH_TO_SB_ENABLE.includes(field);
        if (checkValue && isEnablePush) {
          if (Array.isArray(initValue) && Array.isArray(currentValue)) {
            const hasChanged =
              initValue.length !== currentValue.length || JSON.stringify(initValue) !== JSON.stringify(currentValue);
            enablePush = { enablePush: isEnablePush, hasChanged };
          }
        }
      }
      const { newGroupFieldsToUpdate, pushEnableUpdateValue } = saveGroupChanges(
        id,
        enablePush,
        isPushEnable,
        field,
        groupFields,
        comingFrom,
        handleGroupCriteriaChanges
      );
      if (Object.keys(newGroupFieldsToUpdate).length > 0) {
        store.dispatch(updateGroupFields(newGroupFieldsToUpdate));
      }
      if (pushEnableUpdateValue === true || pushEnableUpdateValue === false) {
        store.dispatch(setPushEnableAction(pushEnableUpdateValue));
      }
    }
  };

  const toggleInput = (index, field) => event => {
    event.stopPropagation();
    const currEditFlags = [...editFlags];
    if (currEditFlags.length) {
      if (currEditFlags[index].includes(field)) {
        currEditFlags.splice(currEditFlags[index].indexOf(field), 1);
      } else {
        currEditFlags[index].push(field);
      }
      setEditFlags(currEditFlags);
    }
  };

  const handlePushEvent = () => {
    const { pricingActions, skyboxId } = props;
    pricingActions.pushEventPrices(skyboxId);
    setIsPushEventModalOpen(false);
  };

  const handlePushEventModalClose = () => {
    setIsPushEventModalOpen(false);
  };

  const handlePushEventModalOpen = () => {
    setIsPushEventModalOpen(true);
  };

  const getBroadcastingStartegyArray = (inclusion, exclusion) => {
    if (inclusion.length) {
      return inclusion
        .filter(key => key in BROADCASTING_STRATEGY_OPTIONS)
        .map(key => BROADCASTING_STRATEGY_OPTIONS[key].includePhrase);
    }
    return exclusion
      .filter(key => key in BROADCASTING_STRATEGY_OPTIONS)
      .map(key => BROADCASTING_STRATEGY_OPTIONS[key].ignorePhrase);
  };

  const handleMarketplaceChange = (index, inclusions, exclusions) => {
    const { focusedPricingGroup, groupsActions } = props;
    const newCriteria = getBroadcastingStartegyArray(inclusions, exclusions);
    groupsActions.updateBroadcastingStrategy({ [focusedPricingGroup]: newCriteria });
    const newMarketplaces = JSON.parse(JSON.stringify(marketplaces));
    if (marketplaces.groups_ids) {
      const groupIdIdx = marketplaces.groups_ids.indexOf(focusedPricingGroup);
      newMarketplaces[groupIdIdx] = handleMarketplaceBasedOnSelection(marketplaces[groupIdIdx], inclusions, exclusions);
      newMarketplaces.groups_ids = marketplaces.groups_ids;
      validateChanges(
        null,
        'inclusions_exclusions',
        marketplaces.groups_ids[groupIdIdx],
        true,
        initMarketplaces,
        newMarketplaces
      );
    } else {
      newMarketplaces[index] = handleMarketplaceBasedOnSelection(marketplaces[index], inclusions, exclusions);
      validateChanges(
        null,
        'inclusions_exclusions',
        marketplaces.groups_ids[index],
        true,
        initMarketplaces,
        newMarketplaces
      );
    }
    store.dispatch(setMPAction(newMarketplaces));
  };

  const focusPricingGroupSection = (pricingGroupId, refresh) => event => {
    if (event !== null && event.stopPropagation) {
      event.stopPropagation();
    }
    const { pricingActions, focusedPricingGroup } = props;
    const currentGroup = groups.find(group => group.id === pricingGroupId);

    const marketplace = currentGroup && currentGroup.marketplace && currentGroup.marketplace[0];
    const sections = groupsMarketplaceComps?.[marketplace]?.[pricingGroupId] ?? [];

    const auditEvent = 'open';
    if (focusedPricingGroup !== pricingGroupId) {
      auditTrail(pricingGroupId, auditEvent, 'killshot_groups');
    }
    if (refresh) {
      pricingActions.setFormTNComparisonData(sections || []);
      pricingActions.setGroup(currentGroup);
    } else if (focusedPricingGroup !== pricingGroupId) {
      pricingActions.setFocusedPricingGroupSection(pricingGroupId);
      pricingActions.setFormTNComparisonData(sections || []);
      pricingActions.setGroup(currentGroup);
      pricingActions.setFocusedPricingGroupMarketplace(marketplace);
      store.dispatch(setCompAllGroupAction(currentGroup.comp_all));
    } else {
      pricingActions.setFocusedPricingGroupSection(pricingGroupId);
      pricingActions.setFormTNComparisonData([]);
      pricingActions.setFocusedPricingGroupMarketplace(null);
      pricingActions.setGroup({ splits: [] });
      store.dispatch(setCompAllGroupAction(false));
    }
  };

  useEffect(() => {
    const { focusedPricingGroup } = props;
    if (!compsLoading && focusedPricingGroup) {
      focusPricingGroupSection(focusedPricingGroup, true)(null);
    }
  }, [compsLoading]);

  useEffect(() => {
    setErrorFlags([]);
    setEditFlags([]);
    store.dispatch(setBadGroups([]));
  }, [history.location.pathname]);

  useEffect(() => {
    const { focusedPricingGroup } = props;
    validateChanges({ comp_all: isCompAllGroup, id: focusedPricingGroup }, 'comp_all');
  }, [isCompAllGroup]);

  const handleSnackbar = () => {
    setIsSnackbar(false);
  };

  const handleGroupEditSubmit = (group, justSave = false) => async () => {
    const { skyboxId, broadcastingStrategy } = props;
    setSaving(true);
    let groupsToFilter = group;
    if (PUSH_TO_SB_V2_ENABLED) {
      groupsToFilter = group.filter(
        g =>
          g.id in groupFields &&
          (hasValues(groupFields, 'enablePush', g.id) || hasValues(groupFields, 'normalFields', g.id))
      );
    }
    const newGroups = groupsToFilter.map(g => {
      const autoBroadcast = g.auto_broadcast;
      const groupListingsIdx = store.getState().groups.listingRows.findIndex(l => l.groupId === g.id);
      const { floor } = g;
      const newGroup = JSON.parse(JSON.stringify(g));

      newGroup.broadcasting_strategy = broadcastingStrategy?.[g.id] ?? [];

      props.pricingActions.setGroupEditingId(g.id);
      if (autoBroadcast > 0 && !Number(floor)) {
        return null;
      }

      if (PUSH_TO_SB_V2_ENABLED) {
        let fields = [];
        if (groupFields[g.id]?.normalFields) {
          fields = [...groupFields[g.id].normalFields];
        }
        if (groupFields[g.id]?.enablePush) {
          fields = [...fields, ...groupFields[g.id].enablePush];
        }
        newGroup.fields = fields;
      }
      const market = getGroupMarkets(g.id, marketplaces);
      const mplaces = Object.keys(market)
        .filter(key => {
          const value = market[key].value.split('_')[1];
          const prefix = value[0];
          return prefix === '+' || prefix === '-';
        })
        .map(key => market[key].value.split('_')[1]);

      if (groupListingsIdx > -1) {
        const groupListings = store.getState().groups.listingRows[groupListingsIdx];
        newGroup.ranks = groupListings.rows.map((row, i) => ({
          rank: i + 1,
          skybox_listing_id: row.skybox_listing_id,
          killshot_group_id: row.groupId,
          include_exclude: mplaces,
          split_type: g.split_type,
          custom_split: g.split_type === 'CUSTOM' ? convertToArray(g.custom_split).join(',') : null,
        }));
      } else {
        newGroup.ranks = g.ranks.map(rank => ({
          ...rank,
          include_exclude: mplaces,
          split_type: g.split_type,
          custom_split: g.split_type === 'CUSTOM' ? convertToArray(g.custom_split).join(',') : null,
        }));
      }
      return newGroup;
    });
    await savePricingGroup(
      skyboxId,
      newGroups,
      true,
      groupsMarketplaceComps,
      zones,
      typeListing,
      false,
      null,
      null,
      updateListingsOnSave,
      justSave
    );
    setGroupCriteria({});

    await store.dispatch(refreshGroups(skyboxId, true));
    setUpdateListingsOnSave(false);
    props.pricingActions.setGroupEditingId(-1);
    setSaving(false);
  };

  const { groupedListingsFirstLoad, skyboxId } = props;

  const dispatch = useDispatch();

  useEffect(() => {
    if (groupedListingsFirstLoad === false && skyboxId) {
      dispatch(refreshInventory(skyboxId));
      dispatch(refreshGroupedListings(skyboxId));
      const fetchData = async () => {
        await dispatch(refreshGroups(skyboxId));
      };
      fetchData();
      setInitSBId(skyboxId);
    } else if (skyboxId && initSBId !== skyboxId) {
      // Reset selected and group
      props.pricingActions.setFocusedPricingGroupSection(null);
      props.pricingActions.setFocusedPricingGroupMarketplace(null);
      props.pricingActions.setGroup({ splits: [] });
      props.pricingActions.clearHashTNComparisonData();
      dispatch(refreshInventory(skyboxId));
      dispatch(refreshGroupedListings(skyboxId));
      const fetchData = async () => {
        await dispatch(refreshGroups(skyboxId));
      };
      fetchData();
      setInitSBId(skyboxId);
    }
  }, [groupedListingsFirstLoad, skyboxId, dispatch]);

  useEffect(() => {}, [groups]);

  const handleGroupMarketplaceSelection = val => {
    const { focusedPricingGroup } = props;
    const selection = val;
    const activeGroup = groups.find(g => g.id === focusedPricingGroup);
    const marketplaceInfo = MARKETPLACE_ITEMS.find(m => m.id === selection);
    const { value: marketplaceValue } = marketplaceInfo;
    let comps = [];
    if (activeGroup) {
      comps = marketplaceValue === 'ticketnetwork' ? activeGroup.tnd_sections : activeGroup.sg_sections;
    }
    props.pricingActions.setFormTNComparisonData(comps);
    if (isCompAllGroup) {
      props.pricingActions.setFormTNComparisonData([]);
      store.dispatch(setGroupsAction(setSectionsGroup(groups, focusedPricingGroup, marketplaceValue, [])));
    }
    store.dispatch(setGroupsAction(setMarketplaceGroup(groups, focusedPricingGroup, marketplaceValue)));
  };

  /**
   * saveZoneFiltersGroup Save to the group all the comps configuration
   * @param {object} zoneFilters configuration of the zones to be save
   * @param {number} index index position of the current group to edit
   */
  const saveZoneFilters = async (zoneFilters, group) => {
    const { pricingActions, groupsActions, activeMarketplace } = props;

    const newCurrCompSections = currTNCompSections.map(c => ({
      id: c.id,
      section_name: c.section_name,
      canonical_name: c.canonical_name,
      low_row: zoneFilters.find(z => z.zoneName === c.zone_name).low,
      high_row: zoneFilters.find(z => z.zoneName === c.zone_name).high,
      zone_type: zoneFilters.find(z => z.zoneName === c.zone_name).type,
      zone_name: c.zone_name,
      killshot_group_id: c.killshot_group_id,
    }));
    const objectType = activeMarketplace === 'ticketnetwork' ? 'tnd_sections' : 'sg_sections';
    const groupEdited = { ...group, [objectType]: newCurrCompSections };
    pricingActions.setGroup(groupEdited);
    store.dispatch(setGroupsAction(setSectionsGroup(groups, group.id, activeMarketplace, newCurrCompSections)));
    pricingActions.setFormTNComparisonData(newCurrCompSections);
    groupsActions.updateGroupsMarketplaceComps(activeMarketplace, group.id, newCurrCompSections);
    validateChanges(groupEdited, objectType, group.id, false, null, null, 'advanceComparison');
  };

  const useFetch = _props => {
    useEffect(() => {
      const fetchData = async () => {
        try {
          if (
            groupSortingCriteria !== 'custom' ||
            _props.groups.length !== marketplaces.length ||
            (_props.groups.length === 1 && groupSortingCriteria === 'custom')
          ) {
            setSettings(await fetchGlobalSettings());
            setCount(0);
            setLoading(false);
          }
        } catch (e) {
          // setError(e);
        }
      };

      if (_props.groups.length !== marketplaces.length || count === 0) {
        fetchData();
      }
    }, [_props.groups]);
  };

  useFetch({ groups });

  const getAnchorListingPrice = ranks => {
    const listingsGrouped = inventory;
    if (ranks.length) {
      const listingData = listingsGrouped.find(o => o.skybox_id === ranks[0].skybox_listing_id);

      if (typeof listingData !== 'undefined') {
        return `$${listingData.list_price || 0}`;
      }
    }
    return 0;
  };

  const groupsUpdateReArrange2 = newGroup => {
    const idx = groups.findIndex(g => g.id === newGroup.id);

    if (groups[idx]) {
      const { sections } = groups[idx];
      // eslint-disable-next-line no-param-reassign
      groups[idx] = {
        ...newGroup,
        sections,
      };
      store.dispatch(setGroupsAction(groups));
    }
  };
  return (
    <>
      <Groups
        settings={settings}
        updateCounter={updateCounter}
        SBEventMeta={eventInfo}
        pricingGroups={groups}
        groupedListings={inventory}
        currTNCompSections={currTNCompSections}
        marketplaces={marketplaces}
        editFlags={editFlags}
        errorFlags={errorFlags}
        currPricingGroups={groups}
        handleGroupEditSubmit={handleGroupEditSubmit}
        handleMarketplaceChange={handleMarketplaceChange}
        focusPricingGroupSection={focusPricingGroupSection}
        getAnchorListingPrice={getAnchorListingPrice}
        groupSortingCriteria={groupSortingCriteria}
        saveZoneFilters={saveZoneFilters}
        handleGroupMarketplaceSelection={handleGroupMarketplaceSelection}
        handleSnackbar={handleSnackbar}
        isPushEventModalOpen={isPushEventModalOpen}
        isSnackbar={isSnackbar}
        toggleInput={toggleInput}
        handlePushEvent={handlePushEvent}
        handlePushEventModalClose={handlePushEventModalClose}
        handlePushEventModalOpen={handlePushEventModalOpen}
        isLoading={isLoading}
        isPricingLoading={isPricingLoading}
        isSaving={isSaving}
        groupsUpdateReArrange2={groupsUpdateReArrange2}
        tags={tags}
        handleGroupCriteriaChanges={handleGroupCriteriaChanges}
        groupCriteria={groupCriteria}
        isCompAllGroup={isCompAllGroup}
        marketplace={typeListing}
        setErrorFlags={setErrorFlags}
        setSaving={setSaving}
        setUpdateListingsOnSave={setUpdateListingsOnSave}
        setGroupSortingCriteria={setGroupSortingCriteria}
        validateChanges={validateChanges}
      />
      <Stack>
        <Snackbar
          open={deleteGroupSnackOpen}
          autoHideDuration={timerDuration}
          onClose={handleSnackBarClose}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <SnackbarContent
            className={
              theme.palette.type === 'dark' ? classes.groupDeletedSnackBarDark : classes.groupDeletedSnackBarLight
            }
            style={{ padding: '0px 70px 0px 16px' }}
            message={
              <Grid container direction="column">
                <Grid item xs={12}>
                  <Grid container direction="row" alignItems="center">
                    <Grid item style={{ paddingLeft: '5px' }}>
                      <Info fontSize="large" style={{ color: theme.palette.type === 'dark' ? '#E1BEE7' : '#9C27B0' }} />
                    </Grid>
                    <Grid item style={{ paddingLeft: '20px' }}>
                      <Typography
                        style={{ color: theme.palette.type === 'dark' ? '#E9E9E9' : '#262626' }}
                        variant="body1"
                        dangerouslySetInnerHTML={{
                          __html: `Group "<strong>${deletedGroupName}</strong>" is empty and has been deleted.`,
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item>
                  <div
                    className={classes.fillBar}
                    style={{ background: theme.palette.type === 'dark' ? '#E1BEE7' : '#9C27B0' }}
                  />
                </Grid>
              </Grid>
            }
          />
        </Snackbar>
      </Stack>
    </>
  );
};

GroupsContainer.propTypes = {
  activeMarketplace: PropTypes.string.isRequired,
  pricingActions: PropTypes.object.isRequired,
  groupsActions: PropTypes.object.isRequired,
  focusedPricingGroup: PropTypes.number,
  SBEventMeta: PropTypes.object.isRequired,
  groups: PropTypes.array.isRequired,
  isPricingLoading: PropTypes.bool.isRequired,
  currTNCompSections: PropTypes.array.isRequired,
  skyboxId: PropTypes.number.isRequired,
  listings: PropTypes.array.isRequired,
  selectedGroup: PropTypes.array.isRequired,
  resetGroup: PropTypes.func.isRequired,
  initialGroups: PropTypes.array.isRequired,
  typeListing: PropTypes.string.isRequired,
  zones: PropTypes.array.isRequired,
  groupedListings: PropTypes.array.isRequired,
  groupedListingsFirstLoad: PropTypes.bool.isRequired,
  refreshGroups: PropTypes.func.isRequired,
  initMarketplaces: PropTypes.array.isRequired,
  groupFields: PropTypes.object.isRequired,
  isPushEnable: PropTypes.bool.isRequired,
  isCompAllGroup: PropTypes.bool.isRequired,
  activeMarketplaces: PropTypes.array.isRequired,
  eventInfo: PropTypes.object.isRequired,
  deleteGroupSnackOpen: PropTypes.bool.isRequired,
  deletedGroupName: PropTypes.string.isRequired,
  marketplaces: PropTypes.array.isRequired,
  compsLoading: PropTypes.bool.isRequired,
  groupsMarketplaceComps: PropTypes.object.isRequired,
  broadcastingStrategy: PropTypes.object.isRequired,
};

GroupsContainer.defaultProps = {
  focusedPricingGroup: null,
};

function mapStateToProps(state) {
  return {
    focusedPricingGroup: state.pricing.ui.focusedPricingGroup,
    SBEventMeta: state.pricing.SBEventMeta,
    currTNCompSections: state.pricing.currTNComparisonSections,
    typeListing: state.pricing.focusedPricingGroupMarketplace,
    selectedGroup: state.pricing.selectedGroup,
    zones: state.zones,
    groupedListings: state.refreshGroupsInventory.groupedListings,
    groupedListingsFirstLoad: state.refreshGroupsInventory.groupedListingsFirstLoad,
    groups: state.refreshGroups.groups,
    isPricingLoading: state.refreshGroups.loadingGroups,
    initialGroups: state.refreshGroups.initialGroups,
    initMarketplaces: state.refreshGroups.initialMarketPlaces,
    groupFields: state.refreshGroups.groupFields,
    isPushEnable: state.refreshGroups.isPushEnable,
    isCompAllGroup: state.groupsStubhubState.isCompAllGroup,
    activeMarketplaces: state.groupsStubhubState.activeMarketplaces,
    eventInfo: state.pricing.eventInfo,
    deleteGroupSnackOpen: state.groups.deleteGroupSnackOpen,
    deletedGroupName: state.groups.deletedGroupName,
    marketplaces: state.refreshGroups.marketplaces,
    compsLoading: state.refreshGroups.compsLoading,
    groupsMarketplaceComps: state.refreshGroups.groupsMarketplaceComps,
    activeMarketplace: state.globals.activeMarketplace,
    broadcastingStrategy: state.refreshGroups.broadcastingStrategy,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    pricingActions: bindActionCreators(pricingActionsImport, dispatch),
    groupsActions: bindActionCreators(groupsActionsImport, dispatch),
    dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(GroupsContainer);
